<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"/>